import { Trans } from "react-i18next";

export default function AiIdeaAnonymityCheckContent({ ownerIdea, status }) {
  return (
    <Trans
      i18nKey={
        status === "success" ? "notifications.aiIdeaAnonymityCheckSuccess"
        : status === "pending" ?
          "notifications.aiIdeaAnonymityCheck"
        : "notifications.aiIdeaAnonymityCheckFailed"
      }
      values={{ idea: ownerIdea?.name || "Deleted" }}
    />
  );
}
